import React, { type ReactElement } from 'react';
import TooltipItem from 'atom-components/tooltip-item';
import BaseMarkerBadge from 'feature-components/badges/marker-badges/base-marker-badge';
import { friendlyMarkerName } from 'helpers/domain-specific/marker.helpers';
import type { BaseCustomerUser } from 'services/assist-api/entities/customer-user/types';
import type { TestInstanceResponseMarkerWithCustomerUser } from 'services/assist-api/entities/test-instance-response-marker/types';
import { allocatedMarkerTooltip } from './deallocation-results.helpers';

type Props = {
  isMark: boolean;
  allocatedMarkerIsMarker: boolean;
  activeMarker: TestInstanceResponseMarkerWithCustomerUser | undefined;
  organisationUser: BaseCustomerUser | undefined;
  autoscored: boolean;
};

export default function DeallocationResultsMarkerBadge({
  isMark,
  allocatedMarkerIsMarker,
  activeMarker,
  organisationUser,
  autoscored
}: Props): ReactElement {
  const tooltip = allocatedMarkerTooltip(
    allocatedMarkerIsMarker,
    friendlyMarkerName(organisationUser),
    isMark
  );

  return (
    <TooltipItem tooltip={tooltip}>
      <BaseMarkerBadge
        displayWarning={allocatedMarkerIsMarker}
        activeMarker={activeMarker}
        organisationUser={organisationUser}
        autoscored={autoscored}
        omitTooltip // Use custom tooltip designed to assist with deallocation.
      />
    </TooltipItem>
  );
}
